document.addEventListener('DOMContentLoaded', () => {
  const handlePrevNex = (carousel) => {
    if (carousel.classList.contains('carousel-video__wrapper') || carousel.classList.contains('carousel__wrapper')) {
      const prevText = carousel.dataset.previousText || '';
      const nextText = carousel.dataset.nextText || '';
 
      const prev = carousel.querySelector('.flickity-prev-next-button.previous')
        prev.append(prevText)
      const next = carousel.querySelector('.flickity-prev-next-button.next')
        next.append(nextText)
      const btnContainer = document.createElement('div')
      btnContainer.classList.add('carousel__prev-next')
      btnContainer.appendChild(prev)
      btnContainer.appendChild(next)
      carousel.appendChild(btnContainer)
    }
  }

  const carousels = document.querySelectorAll('.carousel-pro__wrapper, .js-flickity-carousel');
  carousels?.forEach(carousel => {
    const flkty = new Flickity(carousel, {
      pageDots: carousel.dataset.navDots === 'true' ? true : false,
      wrapAround: carousel.dataset.wrapAround === 'false' ? false : true,
      imagesLoaded: true,
      lazyLoad: 3,
      arrowShape: {
        x0: 50,
        x1: 60,
        y1: 50,
        x2: 65,
        y2: 50,
        x3: 55,
      },
      on: {
        ready: () => handlePrevNex(carousel)
      }
    });
    
    flkty.on('change', () => {
      const event = new Event('carouselChanged')

      // Dispatch the event.
      window.dispatchEvent(event)
    })
    
  })
})
